import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { AppService } from '../app.service';
import { ProfileHeaderComponent } from '../common/profile-header/profile-header.component';
import { SwooshComponent } from '../common/ui-elements/swoosh.component';
import { IntroductionService } from '../services/introduction.service';
import { SafeHtmlPipe } from '../templates/safe.pipe';
import { ResultsBlindSpotsComponent } from './blind-spots/results-blind-spots.component';
import { ResultsCharacteristicsComponent } from './characteristics/results-characteristics.component';
import { ResultsStrengthsComponent } from './strengths/results-strengths.component';

@Component({
  selector: 'results',
  templateUrl: './results.component.html',
  styleUrls: ['./results.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SwooshComponent,
    ProfileHeaderComponent,
    ResultsCharacteristicsComponent,
    ResultsStrengthsComponent,
    NgbNavModule,

    ResultsBlindSpotsComponent,
    SafeHtmlPipe,
    CommonModule,
  ],
})
export class ResultsComponent implements OnInit {
  active: any;
  introduction: string = '';
  isMobileLayout: boolean;
  swooshText = '';
  swooshExternal = '';

  constructor(
    private appService: AppService,
    private introductionService: IntroductionService,
    private route: ActivatedRoute,
  ) {
    this.isMobileLayout = window.innerWidth < 768;
  }

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      if (params['ft'] == 'y') this.introduction = this.introductionService.getContent('WelcomeText');
    });

    window.onresize = () => (this.isMobileLayout = window.innerWidth < 768);

    if (this.appService.getTeamInfo().isElevateTeam) {
      this.swooshText = 'Back to Your Elevate Dashboard';
      this.swooshExternal = this.appService.getTeamInfo().redirectUrl;
    }
  }

  isShowingEmptyState() {
    return this.appService.isShowingEmptyState();
  }
}
